import format from 'date-fns/format';
import { ACTIVE_STATUS, CLIENT, defaultIdForICD, ROLE_MANAGER } from '../../../../utilities/dictionaryConstants';
import { DEFAULT_COUNTRY, DEFAULT_PAGING_SIZE, PAGING_END_INDEX, TAB1 } from '../../../../utilities/staticConfigs';
/**procedure structure */
export const procedure =()=> ({
    id: `New-${crypto.randomUUID()}`,
    patient_death_date: null,
    dos_from: null,
    dos_to: null,
    pos_id: null,
    pos_id_List: [],
    emg: 2,
    cpt_hcpcs: null,
    cpt_hcpcsList: [],
    m1_id: [],
    m2_id: null,
    m3_id: null,
    m4_id: null,
    m1List: [],
    m2List: [],
    m3List: [],
    m4List: [],
    open_pks:[],
    dx_pointers: null,
    fee: "0.00",
    fee_units: "1",
    charges: "0.00",
    cpt_epsdt: 2,
    proced_description: null,
    line_note: null,
    drug_code: null,
    drug_unit_type: null,
    drug_unit_value: null,
    measurement_unit_type: null,
    measurement_unit_value: null,
    anesthesia: null,
    responsibility_type: null,
    payment_doneList: []
});

const professionalClaimDetails=()=>({
    "id": null, "pks": {
        "billing_info_pk": null, "diagnosises_pk": null, "procedures_pks": [], "additional_claim_info_pk": null
    },
    "custom_claim_id": null, "reference_number": null, "posted_date": format(new Date(), 'yyyy-MM-dd'), "service_from_date": format(new Date(), 'yyyy-MM-dd'),
    "service_to_date": format(new Date(), 'yyyy-MM-dd'), "authorization_referral": null, "claim_type": 1, "patient_id": null, "patient_name": null,
    "claim_status": null, "claim_sub_status": null, "identifier": null, "patient": null,
    "locked_by_name": null, "claim_inactive": false, "skip_auto_ev": false, "claim_editable": true, "claim_locked": false, "active": true,"identifierData":[]
})


const billingInfoDetails=()=>({
    "pk": null, "accept_assignments": 1, "patient_signature": 1,
    "insured_signature": 1, "claim": null, "billing_provider": null,
    "rendering_provider": null, "supervising_provider": null, "referring_provider": null,
    "ordering_provider": null, "service_location": null, "service_location_value": null,
    "primary_insurance": null, "secondary_insurance": null, "tertiary_insurance": null,
    "insurer_relation": null, "claim_fequency": 1, "original_claim_id": null,
    "claim_reference": null, "payer_info": [], "added_insurance_info": [],
    "payerInsuranceList": [],"primaryInsuranceDataList": [],"secondaryInsuranceDataList": [],
    "tertiaryInsuranceDataList": [], "primarypolicyId": null, "insurancePrimary": null, "secondarypolicyId": null,
    "insurancesecondary": null,"tertiarypolicyId": null,"insuranceTertiary": null,
    "primaryPayerId":null,"secondaryPayerId":null,"tertiaryPayerId":null,
})

const serviceLineDetails=()=>({
    "icd": defaultIdForICD,
    "diagnosis1": null, "diagnosis2": null, "diagnosis3": null, "diagnosis4": null, "diagnosis5": null, "diagnosis6": null,
    "diagnosis7": null, "diagnosis8": null, "diagnosis9": null, "diagnosis10": null, "diagnosis11": null, "diagnosis12": null,
    "diagnosis1List": [], "diagnosis2List": [], "diagnosis3List": [], "diagnosis4List": [], "diagnosis5List": [], "diagnosis6List": [],
    "diagnosis7List": [], "diagnosis8List": [], "diagnosis9List": [], "diagnosis10List": [], "diagnosis11List": [], "diagnosis12List": [],
    "procedures": [],"responsibility_type":[],"claim_status":[],"claim_sub_status":[]
})

const additionalClaimDetails=()=>({
    "id": null, "employment": 2, "other_accident": null, "accident_date": null, "last_menstural_date": null,
    "initial_treatment_date": null, "last_seen_date": null,"sample_received_date":null, "unable_work_from_date": null,
    "unable_work_to_date": null, "hospitalization_from_date": null, "hospitalization_to_date": null,
    "assumed_care_date": null, "disability_begin_date": null, "disability_end_date": null,
    "relinquished_date": null, "mammography_cert_number": null, "care_plan_number": null,
    "service_authorization_code": null, "clia_number": null, "ide_number": null, "project_demonstration_id": null,
    "special_program_code": null, "patient_homebound": null, "claim_delay_reason": null,
    "claim_note": null, "lab_sales_rep": null, "claim_service_type": null, "clinic_site_name": null,
    "accession_number": null, "ambulance_claim": 2, "weight": null,
    "distance": null, "return_trip_reason": null, "stretcher_reason": null, "certification": null,
    "condition_indicator": {
        "patient_admitted_hospital": false, "patient_moved_by_stretcher": false, "patient_unconscious_shock": false,
        "patient_transported_emergency": false, "patient_physically_restrained": false, "patient_visible_haemorrhaging": false,
        "ambulance_service_medical_necessary": false, "patient_confined_bed_chair": false,
    },
    "lab_notes": null,
    "claim": null, "accident": null, "state": null, "transport_reason": null,
    "pickup_location_data": {
        "street1": null, "street2": null, "city": null, "state": null, "country": DEFAULT_COUNTRY, "zip_code": null
    },
    "dropoff_location_data": {
        "street1": null, "street2": null, "city": null, "state": null, "country": DEFAULT_COUNTRY, "zip_code": null
    },
    "transport_code": null
})

export const initialState = {
    dataLoading: false,
    editDetailsLoading:false,
    apiError: null,
    activeParentTab: 'claim',
    activeSubTab:TAB1,
    claimSearchQuery: null,
    searchClaimsTable: {
        initialOrderingClaimId: true,
        initialOrderingDos: true,
        initialOrderingBillDate: true,
        initialOrderingPatientName: true,
        patientPk: "",
        patientSelected: [],
        patientAdvanceSearchData: [],
        searchByClaimId: null,
        activeStatus: ACTIVE_STATUS.find((item) => item.name == "Active")?.id,
        dosFrom: null,
        dosTo: null,
        claimEnteredFrom: null,
        claimEnteredTo: null,
        sampleReceivedDateFrom: null,
        sampleReceivedDateTo: null,
        pageSize: DEFAULT_PAGING_SIZE,
        page: 1,
        orderType: "",
        sortField: "",
        totalPages: 0,
        startIndex: 0,
        endIndex: PAGING_END_INDEX,
        tableData: [],
        isReset: false,
        labSalesRep: null,
        clinicSiteName: null,
        claimServiceType: null
    },
    tabsOpen: 0,
    selectedClaimType: null,
    claimPK: null,
    diagnosis_pk: null,
    billing_info_pk: null,
    addition_info_pk: null,
    duplicateData:{},
    patient_PK:null,
    professionalClaimDetails: professionalClaimDetails(),
    billingInfoDetails: billingInfoDetails(),
    serviceLineDetails: serviceLineDetails(),
    diagnosisValidation: {
        "diagnosis1": "", "diagnosis2": "", "diagnosis3": "", "diagnosis4": "", "diagnosis5": "", "diagnosis6": "",
        "diagnosis7": "", "diagnosis8": "", "diagnosis9": "", "diagnosis10": "", "diagnosis11": "", "diagnosis12": ""  
    },
    additionalClaimDetails: additionalClaimDetails(),
    insuranceLoading: false,
    ModifiersValidated: [],
    inputM1Validated: [],
    inputM2Validated: [],
    inputM3Validated: [],
    inputM4Validated: [],
    checkForDuplicatediagnosis: false,
    diagnosisesValidated:true,
    CallInsurance: false,
    infoLoaded: false,
    patientSelectedData: [],
    patientAdvanceSearchData: [],
    selectedPatient: null,
    insuranceCompleted: false,
    serviceLocationPosList: [],
    notifyMessage: null,
    showNotification: false,
    statusTag:null,
    identifierData: [],
    isClose: false,
    alertMessage: "",
    alertModalOpen: false,
    patientAlertModal:false,
    saveConfirmation: false,
    saveCloseConfirmation: false,
    inactiveClaimModal: false,
    activeClaimModal: false,
    patientHistoryModal:false,
    formWarningMessage: null,
    formWarningData: [],
    formWarningStatus: false,
    savedClaimDetails: {
        "claimId": null,
        "claimPK": null,
        "isClose": false,
        "isSave":false
    },
    patientHistoryICD: [],
    patientHistoryCPT:[],
    claimSubStatus:[],
    deleteProcedureModal:false,
    deleteProcedure:{
        procedureId:null,
        procedureIndex:null
    },
    fee_field_status:{
        all:false,
        single:false
    },
    fee_confirmation_modal:false,
    patientLedger: {
        isOpen: false,
        loading: false,
        isClaimLoading: false,
        patientId: null,
        summaryData: {},
        claimsData: [],
        expandedClaims: {},
    },
    viewActivity: {
        isOpen: false,
        activeTab: 0,
        claimPK: null,
        loading: {
            workflow: false,
            logs: false,
            comments: false
        },
        workflowData: [],
        logsData: [],
        escalationCommentsData: [],
        auditorCommentsData:[],
        total_comments_count_escalation:0,
        total_comments_count_auditor:0,
        error: null
    },
    voidToggleModal: {
        show: false,
        isVoiding: true
    },
    selectedVoidId: null,
    duplicateDataSet: {
        professionalClaimDetails: professionalClaimDetails(),
        billingInfoDetails: billingInfoDetails(),
        serviceLineDetails: serviceLineDetails(),
        additionalClaimDetails: additionalClaimDetails(),
    },
    isClaimClose:false,
    isOpen: false,
    ClaimSummayData: null,
    ClaimSummayLoading: false,
    ClaimSummayError: null,
    openCompleteClaimModal: false,
    claim_stage_ids_clicked: [],
    claim_stages: [],
    practiceUsers: [],
    escalationDetails: {},
    openReviewResolveModal:false,
    escalationResultComplete:false,
    requestSupportOpen:false,
    requestRespondOpen: false,
    selectedStageIds:[],
    reportsTo:null,
    reasonOptions:[],
    stageOptions:[],
    submitting:false,
    activeTab: CLIENT,
    responsibilityType:[],
    fieldServiceInfo:{},
    RequestDialogDetails:{
        reasonId:[],
        explain:null,
        role:ROLE_MANAGER,
        assignTo:null,

        client: {
            stageIds: [],
            reasonId: [],
            explain: ""
        },

        manager: {
            stageIds: [],
            reasonId: [],
            explain: ""
        }
    },
    deEscalationDetails:{
        remarks:"",
        assignTo:""
    },

    makeInProgressStatus:false,
    claim_id_open_in_new_tab:"",
    arNotes:{
        "id":"",
        "ar_notes_List":[],
        "follow_up_notes":[],
        "notes":"",
        "ar_status_code": "",
        "ar_action_code": "",
        "next_followup_date":"",
        "selected_template_id": "",
        "loading": false,
        "original_ar_notes": null
    },
    openTabPks: [],
    dropDownListData: {
        isLoading: false,
        isErrorGettingDropdownData: false,
        arStatusList: [],
        arActionCodeList: []
    },
    openAuditReviewModal:false,
    holdModal: {
        isOpen: false,
        reason: "",
        status: "",
        options: [],
        loading: false,
        error: null,
    },
    releaseModal:{
        releaseReason: "",
        reason: "",
    },
    selection: {
        claimIDs: [],
        isAllChecked: false,
    },
    ui: {
        moreActionsAnchor: null,
        statusUpdateModalOpen: false,
    },
    workflowDetails: null,
    masterWorkflowList: [],
    auditorIssuesList:[],
    loadingComments:false,
    editingIssueId:null,
    fieldList:[],
    auditReviewDetails:{
        exceptionType:[],
        field:[],
        comments:"",
    },
    active_escalation: null,
    isSubmittingResponse: false,
    isClaimHold:false
}